<template>
  <v-alert
    v-bind="vuetifyProps"
    border="left"
    class="alert-container"
    colored-border
    dense
    outlined
    @input="$emit('input', $event)"
  >
    <template v-slot:prepend>
      <slot name="customIcon"></slot>
      <v-icon
        v-if="vuetifyProps.icon"
        class="me-2"
        :color="vuetifyProps.color"
        >{{ vuetifyProps.icon }}</v-icon
      >
    </template>
    <p
      class="ma-0 pa-0 blue-grey--text text--darken-3"
      :class="textClass ? textClass : 'label'"
      v-html="$sanitize(text, { allowedTags: ['a', 'b', 'br'] })"
    />

    <template v-slot:append>
      <Button
        v-if="secondaryButtonText"
        class="me-3"
        data-testid="alert-button-secondary"
        size="small"
        :color="secondaryButtonColor"
        :disabled="secondaryButtonDisabled"
        :plain="secondaryButtonPlain"
        :text="secondaryButtonText"
        @click="$emit('secondaryButtonClick')"
      />
      <Button
        v-if="buttonText"
        class="ml-4"
        size="small"
        :color="vuetifyProps.color"
        :disabled="disableButton"
        :plain="buttonPlain"
        :text="buttonText"
        @click="$emit('buttonClick')"
      />
      <slot name="append" />
      <v-icon
        v-if="dismissable"
        size="20"
        class="ms-3"
        color="blue-grey"
        @click="$emit('dismiss')"
        >mdi-close-circle</v-icon
      >
    </template>
  </v-alert>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'Alert',
  components: {
    Button,
  },
  props: {
    dismissable: Boolean,
    vuetifyProps: Object,
    text: String,
    buttonText: String,
    disableButton: Boolean,
    textClass: String,
    buttonPlain: {
      type: Boolean,
      default: true,
    },
    secondaryButtonText: String,
    secondaryButtonColor: {
      type: String,
      default: 'red',
    },
    secondaryButtonDisabled: Boolean,
    secondaryButtonPlain: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.alert-container {
  background-color: $color-white !important;
}
</style>
